var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"site-icon",attrs:{"width":_vm.size,"height":_vm.size,"viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":_vm.stroke,"stroke-linecap":"round","stroke-linejoin":"round","aria-hidden":"true","focusable":"false"}},[_c('path',{attrs:{"d":_vm.path}})])
}
var staticRenderFns = []

export { render, staticRenderFns }